import axios from "axios";
import * as Sentry from "@sentry/react";

const apiCDSApp = axios.create({
  baseURL: `${process.env.REACT_APP_CDS_API_URL}/v1`.replace("/public", "/app"),
});

apiCDSApp.interceptors.response.use(
  (response) => response,
  (error) => {
    const sentryError = new Error(error.message);
    Sentry.captureException(sentryError, (scope) => {
      scope.setTransactionName(`CDS Api: ${error.code}`);
      scope.setTag("CDS Api", error.code);
      scope.setExtra("data", error);
    });
    return Promise.reject(error);
  }
);

export default apiCDSApp;
